import React from 'react';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import BasicFormField from '../../../common/formFields/basicFormField';
import { t } from '../../../../modules/infra/i18n';

const Passcode = () => (
  <div>
    <div className="c-heading c-heading--lightgrey c-wrapper u-p0 u-mb-">
      {t('barber:passcode.heading')}
    </div>
    <div className="u-ph">
      <div className="layout">
        <CheckboxSwitch
          name="requirePasscode"
          id="requirePasscode"
          label={t('barber:passcode.require_checkbox')}
          wrapperClass="layout__item"
        />
        <BasicFormField label={t('barber:passcode.code_label')} name="passcode" />
      </div>
    </div>
  </div>
);

export default Passcode;
